var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeMfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0591 8.0751C24.1795 8.0751 27.9663 10.3251 29.9587 13.8802L28.2971 14.6329L28.1393 14.7044L28.2801 14.8053L33.0811 18.2461L33.2219 18.347L33.2389 18.1746L33.8187 12.2962L33.8357 12.1239L33.6779 12.1953L31.9431 12.9807C29.5945 8.65066 25.0317 5.9 20.0591 5.9C14.763 5.9 9.92875 9.01783 7.7423 13.8435C7.49434 14.3903 7.73714 15.0344 8.28417 15.2827L8.28436 15.2828C8.83052 15.5294 9.47512 15.2885 9.72346 14.7408L9.72347 14.7408C11.558 10.6916 15.6149 8.0751 20.0591 8.0751Z",
    fill: "#5B5B5B",
    stroke: "#5B5B5B",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7349 31.0872C16.6146 31.1179 12.811 28.8962 10.7923 25.356L12.4482 24.591L12.6054 24.5183L12.4639 24.4185L7.63731 21.0136L7.49579 20.9137L7.48007 21.0862L6.94417 26.9688L6.92846 27.1413L7.08568 27.0687L8.81455 26.2704C11.1954 30.5827 15.7786 33.2993 20.7511 33.2622C26.047 33.2227 30.8579 30.0689 33.0083 25.2271C33.2522 24.6784 33.0046 24.0361 32.4557 23.7919L32.4555 23.7918C31.9075 23.5494 31.2647 23.795 31.0205 24.3445L31.0205 24.3446C29.2162 28.4073 25.179 31.054 20.7349 31.0872Z",
    fill: "#EB5424",
    stroke: "#EB5424",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeMfa);
export default __webpack_public_path__ + "static/media/Exchange MFA.e505324d30f021c333a556b097cea493.svg";
export { ForwardRef as ReactComponent };